import request from '@/utils/http-util'
import { baseUrl } from '/env'

export function executeSelectApi(data) {
    return request({
        url: baseUrl+'/sql/executeSelect',
        method: 'post',
        data
    })
}

export function executeSelectKey(data) {
    return request({
        url: baseUrl+'/sql/getSqlColumn',
        method: 'post',
        data
    })
}